module.exports = __webpack_public_path__ + "static/media/2021_2A3A1173.c1820b8f.jpg";